import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Size2b01934yxlz5f as Size } from '../../models/Rect.mjs';
import { BaseListenable1u3g4s45l82o6 as BaseListenable } from '../../../../../../reactive/com/lightningkite/reactive/core/abstracts.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function resizeObserver(_this__u8e3s4) {
  return resizeObserver$1().new_com_lightningkite_kiteui_views_direct__no_name_provided__h6w28u_k$(_this__u8e3s4);
}
function mutationObserver(_this__u8e3s4, recursive) {
  return mutationObserver$1().new_com_lightningkite_kiteui_views_direct__no_name_provided__uwn8ck_k$(_this__u8e3s4, recursive);
}
function measureByDuplicate(_this__u8e3s4, max) {
  var tmp = _this__u8e3s4.cloneNode(true);
  var clone = tmp instanceof HTMLElement ? tmp : THROW_CCE();
  clone.style.visibility = 'hidden';
  clone.style.width = max.width_1 < 9999.0 ? '' + max.width_1 + 'px' : 'unset';
  clone.style.height = max.height_1 < 9999.0 ? '' + max.height_1 + 'px' : 'unset';
  clone.style.maxWidth = 'unset';
  clone.style.maxHeight = 'unset';
  clone.style.position = 'fixed';
  ensureNotNull(document.body).appendChild(clone);
  var out = new (Size())(clone.scrollWidth + 1.0, clone.scrollHeight + 1.0);
  ensureNotNull(document.body).removeChild(clone);
  return out;
}
var resizeObserver$1Class;
function resizeObserver$1() {
  if (resizeObserver$1Class === VOID) {
    class $ extends BaseListenable() {
      constructor($this_resizeObserver) {
        return new.target.new_com_lightningkite_kiteui_views_direct__no_name_provided__h6w28u_k$($this_resizeObserver);
      }
      static new_com_lightningkite_kiteui_views_direct__no_name_provided__h6w28u_k$($this_resizeObserver, $box) {
        if ($box === VOID)
          $box = {};
        $box.$this_resizeObserver_1 = $this_resizeObserver;
        var $this = this.new_com_lightningkite_reactive_core_BaseListenable_e3suws_k$($box);
        $this.observer_1 = null;
        return $this;
      }
      activate_yijg9v_k$() {
        var tmp = this;
        // Inline function 'kotlin.apply' call
        var this_0 = new ResizeObserver((_unused_var__etf5q3, _unused_var__etf5q3_0) => {
          this.invokeAllListeners_uusj2y_k$();
          return Unit_instance;
        });
        var $this$apply = this_0;
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.onElement' call
        var this_1 = this.$this_resizeObserver_1;
        var tmp0_safe_receiver = this_1.element_1;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          $this$apply.observe(tmp0_safe_receiver);
          tmp_0 = Unit_instance;
        }
        if (tmp_0 == null) {
          this_1.elementToDo_1.add_utx5q5_k$((it) => {
            $this$apply.observe(it);
            return Unit_instance;
          });
        }
        tmp.observer_1 = this_0;
      }
      deactivate_pmdz1g_k$() {
        var tmp0_safe_receiver = this.observer_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.disconnect();
        }
        this.observer_1 = null;
      }
    }
    initMetadataForClass($);
    resizeObserver$1Class = $;
  }
  return resizeObserver$1Class;
}
var mutationObserver$1Class;
function mutationObserver$1() {
  if (mutationObserver$1Class === VOID) {
    class $ extends BaseListenable() {
      constructor($this_mutationObserver, $recursive) {
        return new.target.new_com_lightningkite_kiteui_views_direct__no_name_provided__uwn8ck_k$($this_mutationObserver, $recursive);
      }
      static new_com_lightningkite_kiteui_views_direct__no_name_provided__uwn8ck_k$($this_mutationObserver, $recursive, $box) {
        if ($box === VOID)
          $box = {};
        $box.$this_mutationObserver_1 = $this_mutationObserver;
        $box.$recursive_1 = $recursive;
        var $this = this.new_com_lightningkite_reactive_core_BaseListenable_e3suws_k$($box);
        $this.observer_1 = null;
        return $this;
      }
      activate_yijg9v_k$() {
        var tmp = this;
        // Inline function 'kotlin.apply' call
        var this_0 = new MutationObserver((rec, _unused_var__etf5q3) => {
          var tmp0_elvis_lhs = this.$this_mutationObserver_1.element_1;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            return Unit_instance;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var e = tmp;
          // Inline function 'kotlin.js.asDynamic' call
          var tmp_0 = e.__suppressMutationObserverStyle;
          var tmp1_elvis_lhs = tmp_0 instanceof ArrayList() ? tmp_0 : null;
          var suppressedStyleChanges = tmp1_elvis_lhs == null ? ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$() : tmp1_elvis_lhs;
          // Inline function 'kotlin.js.asDynamic' call
          var tmp_1 = e.__suppressMutationObserverClass;
          var tmp2_elvis_lhs = tmp_1 instanceof ArrayList() ? tmp_1 : null;
          var suppressedClassChanges = tmp2_elvis_lhs == null ? ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$() : tmp2_elvis_lhs;
          var tmp3_elvis_lhs = e.getAttribute('style');
          var s = tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs;
          var c = e.className;
          var anyNotSuppressed = false;
          var inductionVariable = 0;
          var last = rec.length;
          $l$loop_1: while (inductionVariable < last) {
            var it = rec[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            var suppressedStyle = it.type === 'attributes' && it.attributeName === 'style' && equals(it.target, e) && suppressedStyleChanges.contains_aljjnj_k$(s);
            if (suppressedStyle) {
              continue $l$loop_1;
            }
            var suppressedClass = it.type === 'attributes' && it.attributeName === 'class' && equals(it.target, e) && suppressedClassChanges.contains_aljjnj_k$(c);
            if (suppressedClass) {
              continue $l$loop_1;
            }
            if (!(it.attributeName == null)) {
              var tmp_2 = it.target;
              var tmp4_safe_receiver = tmp_2 instanceof HTMLElement ? tmp_2 : null;
              var newValue = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.getAttributeNS(it.attributeNamespace, ensureNotNull(it.attributeName));
              var tmp5_elvis_lhs = it.oldValue;
              var tmp_3 = tmp5_elvis_lhs == null ? '' : tmp5_elvis_lhs;
              if (tmp_3 === (newValue == null ? '' : newValue))
                continue $l$loop_1;
            }
            anyNotSuppressed = true;
          }
          suppressedStyleChanges.clear_j9egeb_k$();
          suppressedClassChanges.clear_j9egeb_k$();
          var tmp_4;
          if (anyNotSuppressed) {
            this.invokeAllListeners_uusj2y_k$();
            tmp_4 = Unit_instance;
          }
          return Unit_instance;
        });
        var $this$apply = this_0;
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.onElement' call
        var this_1 = this.$this_mutationObserver_1;
        var tmp0_safe_receiver = this_1.element_1;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          var init = {childList: true, attributes: true, attributeOldValue: true};
          init.subtree = this.$recursive_1;
          // Inline function 'kotlin.js.unsafeCast' call
          $this$apply.observe(tmp0_safe_receiver, init);
          tmp_0 = Unit_instance;
        }
        if (tmp_0 == null) {
          this_1.elementToDo_1.add_utx5q5_k$((it) => {
            var init = {childList: true, attributes: true, attributeOldValue: true};
            init.subtree = this.$recursive_1;
            // Inline function 'kotlin.js.unsafeCast' call
            $this$apply.observe(it, init);
            return Unit_instance;
          });
        }
        tmp.observer_1 = this_0;
      }
      deactivate_pmdz1g_k$() {
        var tmp0_safe_receiver = this.observer_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.disconnect();
        }
        this.observer_1 = null;
      }
    }
    initMetadataForClass($);
    mutationObserver$1Class = $;
  }
  return mutationObserver$1Class;
}
//region block: exports
export {
  measureByDuplicate as measureByDuplicate50c5johgli0l,
  mutationObserver as mutationObserver1idzofyamtyii,
  resizeObserver as resizeObserver1rxn81hcox9er,
};
//endregion

//# sourceMappingURL=helpers.commonHtml.js.mjs.map
